export const DEFAULT_START = '09:00';
export const DEFAULT_END = '22:00';
export const DEFAULT_SPLIT_DURATION_SECONDS = 4 * 60 * 60;
